import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/adminApi';
import { Loader2, Building2, Mail, Ban } from 'lucide-react';

export default function LeadsPanel() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    adminApi.get('/admin/leads').then((r) => setData(r.data)).catch(() => setData({ items: [], total_companies: 0, total_emails: 0 }));
  }, []);

  if (!data) return <div className="text-white/40 py-10 text-center"><Loader2 className="animate-spin inline" /></div>;

  const items = data.items.filter((l) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return l.business.toLowerCase().includes(s) || l.category.toLowerCase().includes(s)
      || l.location.toLowerCase().includes(s) || l.emails.join(' ').includes(s);
  });

  return (
    <div className="space-y-6" data-testid="leads-panel">
      <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4 flex items-start gap-3">
        <Ban className="text-yellow-400 mt-0.5 shrink-0" size={18} />
        <p className="text-yellow-200/90 text-sm">
          <strong>Solo ricerca (research_only).</strong> Contatti B2B pubblici con <strong>consenso marketing = NO</strong>.
          Non vengono usati per email o campagne, e restano separati dai clienti.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5" data-testid="stat-lead-companies">
          <div className="flex items-center gap-2 text-white/50 text-xs uppercase tracking-widest"><Building2 size={14} /> Aziende</div>
          <div className="text-3xl font-black text-white mt-2">{data.total_companies}</div>
        </div>
        <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5" data-testid="stat-lead-emails">
          <div className="flex items-center gap-2 text-white/50 text-xs uppercase tracking-widest"><Mail size={14} /> Email contatto</div>
          <div className="text-3xl font-black text-white mt-2">{data.total_emails}</div>
        </div>
      </div>

      <input
        data-testid="leads-search"
        value={search} onChange={(e) => setSearch(e.target.value)}
        placeholder="Cerca azienda, categoria, località…"
        className="w-full bg-black border border-white/15 rounded-lg px-4 py-2.5 text-white text-sm outline-none focus:border-red-500"
      />

      <div className="bg-[#0d0d0d] border border-white/10 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="leads-table">
            <thead>
              <tr className="text-left text-white/40 text-xs uppercase tracking-wider border-b border-white/10">
                <th className="px-4 py-3">Azienda</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Categoria</th>
                <th className="px-4 py-3">Località</th>
                <th className="px-4 py-3">Stato</th>
              </tr>
            </thead>
            <tbody>
              {items.map((l) => (
                <tr key={l.id} className="border-b border-white/5 text-white/80 align-top">
                  <td className="px-4 py-3 font-semibold text-white">{l.business}</td>
                  <td className="px-4 py-3 text-white/60">
                    {l.emails.map((e) => <div key={e}>{e}</div>)}
                  </td>
                  <td className="px-4 py-3 text-white/60 max-w-xs">{l.category}</td>
                  <td className="px-4 py-3 text-white/60">{l.location}</td>
                  <td className="px-4 py-3"><span className="text-xs text-yellow-300/90 whitespace-nowrap">{l.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
